import { Component, Inject, Optional } from '@angular/core';
import { SupportFaqDialogComponent } from '../../dialogs/support-faq-dialog/support-faq-dialog.component';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DialogData } from '@xt/ui-kit';
import { ActionDialogData } from './action-dialog-data.model';

@Component({
  selector: 'xt-portal-action-dialog',
  templateUrl: './action-dialog.component.html',
  styleUrls: ['./action-dialog.component.scss'],
    standalone: false
})
export class ActionDialogComponent {
  dialogConfig: DialogData;

  constructor(
    public dialogRef: MatDialogRef<ActionDialogComponent>,
    public dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: ActionDialogData,
  ) {
    this.dialogConfig = {
      title: this.data.title,
    };
  }

  closeDialog(next: boolean): void {
    if (this.data.isSupportDialog && !next) {
      this.dialog.open(SupportFaqDialogComponent, {
        width: '880px',
        data: {
          type: 'allFaqs',
        },
      });
    }
    this.dialogRef.close(next);
  }
}
